import type { ShipmentCategoryEntity } from '@/libs/api'

export const mapToShipmentCategoryFieldName = (
  shipmentCategory: ShipmentCategoryEntity
) => {
  return `${shipmentCategory.code}/${shipmentCategory.name}`
}
